/*******************************************************************************
//
//
//
//  #MODAL
//
//
//
*******************************************************************************/

var Modal = (function () {
  var html = document.documentElement;
  var focusedElementBeforeModal;
  var component = document.querySelector('#modal-pop-up');
  var triggers = document.querySelectorAll('.js-modal-trigger');

  var _addEventListeners = function () {
      for (var i = 0; i < triggers.length; i++) {
          triggers[i].addEventListener('click', function (event) {
              event.preventDefault();

              _open(this.dataset.target);
          });
      }

      component
          .querySelector('.js-modal-pop-up-close')
          .addEventListener('click', function () {
              var inFifteenMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);

              Cookies.set('ciwc-modal-pop-up', 'closed', {
                  expires: inFifteenMinutes
              });

              _close();
          });
  };

  var _checkPopUpPermission = function () {
      var popUpState = Cookies.get('ciwc-modal-pop-up');

      if(popUpState != 'closed') {
          setTimeout(function () {
              _open('.js-modal-pop-up');
          }, 1000);
      }
  };

  var _open = function (target) {
      html.classList.add('is-disable-scroll');

      var modal = document.querySelector(target);

      // Store current focused element
      focusedElementBeforeModal = document.activeElement;

      // Listen for keyboard
      modal.addEventListener('keydown', _addKeyboardListeners);

      // Close Modal
      var closeButtons = modal.querySelectorAll('.js-modal-close');

      for (var i = 0; i < closeButtons.length; i++) {
          closeButtons[i].addEventListener('click', _close);
      }

      // Find all focusable children
      var focusableElementsString =
          'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
      var focusableElements = modal.querySelectorAll(focusableElementsString);

      focusableElements = Array.prototype.slice.call(focusableElements);

      var firstTabStop = focusableElements[0];
      var lastTabStop = focusableElements[focusableElements.length - 1];

      modal.classList.add('is-active');

      // Focus on first element in Modal
      firstTabStop.focus();

      function _addKeyboardListeners(event) {
          if (event.keyCode === 9) {
              if (event.shiftKey) {
                  if (document.activeElement === firstTabStop) {
                      event.preventDefault();
                      lastTabStop.focus();
                  }
              } else {
                  if (document.activeElement === lastTabStop) {
                      event.preventDefault();
                      firstTabStop.focus();
                  }
              }
          }

          if (event.keyCode === 27) {
              _close();
          }
      }
  };

  var _close = function () {
      var modal = document.querySelector('.c-modal.is-active');

      html.classList.remove('is-disable-scroll');

      if (modal) {
          modal.classList.remove('is-active');

          focusedElementBeforeModal.focus();
      }
  };

  var _init = function () {
      if(typeof(component) != 'undefined' && component != null) {
          _addEventListeners();
          _checkPopUpPermission();
      }
  };

  return {
      init: _init,
  };
})();
